import { asWorkspaceId, ReachWorkspace, ReachWorkspaceType } from '~app-client/workspaces/types';

export const unassignedWorkspaceId = asWorkspaceId('-1');
export const trashedWorkspaceId = asWorkspaceId('-2');

export function workspaceUnasignedNodesTransformer(count: number): ReachWorkspace {
	const now = Date.now();

	return {
		id: unassignedWorkspaceId,
		type: ReachWorkspaceType.UNASSIGNED_NODES,
		name: 'Unassigned Nodes',
		createdAt: now,
		updatedAt: now,
		count: count,
		lastSearch: Number.NEGATIVE_INFINITY,
	};
}

export function workspaceTrashedNodesTransformer(count: number): ReachWorkspace {
	const now = Date.now();

	return {
		id: trashedWorkspaceId,
		type: ReachWorkspaceType.TRASHED_NODES,
		name: 'Trash',
		createdAt: now,
		updatedAt: now,
		count,
		lastSearch: Number.NEGATIVE_INFINITY,
	};
}
